// /* eslint-disable */
// 'use client';

// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Text,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Spinner,
//   Badge,
//   Input,
//   useToast,
//   useColorModeValue,
// } from '@chakra-ui/react';
// import axios from 'axios';
// import Card from 'components/card/Card';

// export default function ReviewRating() {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');

//   const toast = useToast();
//   const textColor = useColorModeValue('secondaryGray.900', 'white');

//   // ✅ ENV BASE URL (AUTO SWITCH LOCAL / LIVE)
//   const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/');

//   // ✅ TOKEN (same as your system)
//   const token =
//     localStorage.getItem('adminToken') || localStorage.getItem('token');

//   const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

//   // ✅ FETCH DATA
//   const fetchRatings = async () => {
//     setLoading(true);
//     try {
//       if (!token) {
//         throw new Error('Admin token missing from localStorage');
//       }

//       const requestUrl = `${baseUrl?.replace(/\/?$/, '/') || 'http://localhost:4000/'}api/admin/all-ratings`;
//       const res = await axios.get(requestUrl, {
//         headers,
//       });

//       setData(res.data.data || []);
//     } catch (err) {
//       toast({
//         title: 'Error fetching ratings',
//         description: err.response?.data?.message || 'Something went wrong',
//         status: 'error',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRatings();
//   }, []);

//   const filteredData = data.filter((item) => {
//     const q = searchTerm.trim().toLowerCase();
//     if (!q) return true;

//     return [
//       item.user?.name,
//       item.user?.email,
//       item.targetType,
//       item.targetName,
//       item.review,
//       item.rating?.toString(),
//     ]
//       .filter(Boolean)
//       .some((field) => field.toString().toLowerCase().includes(q));
//   });

//   return (
//     <Box pt={{ base: '200px', md: '120px', xl: '120px' }}>
//       <Card p="20px" overflowX="auto">
//         <Text color={textColor} fontSize="xl" fontWeight="700" mb="20px">
//           Review & Ratings
//         </Text>

//         <Input
//           mb="16px"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder="Search by user, email, rating, type, target or review"
//           maxW={{ base: '100%', md: '400px' }}
//         />

//         {loading ? (
//           <Spinner />
//         ) : (
//           <Table variant="simple" size="sm">
//             <Thead bg={useColorModeValue('gray.50', 'navy.800')}>
//               <Tr>
//                 <Th>User</Th>
//                 <Th>Email</Th>
//                 <Th>Rating</Th>
//                 <Th>Review</Th>
//                 <Th>Type</Th>
//                 <Th>Target</Th>
//                 <Th>Date</Th>
//               </Tr>
//             </Thead>

//             <Tbody>
//               {filteredData.length > 0 ? (
//                 filteredData.map((item) => (
//                   <Tr key={item._id}>
//                     <Td fontWeight="bold">{item.user?.name || '-'}</Td>

//                     <Td>{item.user?.email || '-'}</Td>

//                     <Td>
//                       <Badge colorScheme="green">{item.rating} ⭐</Badge>
//                     </Td>

//                     <Td maxW="200px">{item.review || '—'}</Td>

//                     <Td>
//                       <Badge colorScheme="purple">{item.targetType}</Badge>
//                     </Td>

//                     <Td>{item.targetName || '-'}</Td>

//                     <Td>
//                       <Badge colorScheme="blue">
//                         {new Date(item.createdAt).toLocaleDateString()}
//                       </Badge>
//                     </Td>
//                   </Tr>
//                 ))
//               ) : (
//                 <Tr>
//                   <Td colSpan="7" textAlign="center">
//                     No Ratings Found
//                   </Td>
//                 </Tr>
//               )}
//             </Tbody>
//           </Table>
//         )}
//       </Card>
//     </Box>
//   );
// }

/* eslint-disable */
'use client';

import {
  Box,
  Flex,
  Text,
  useColorModeValue,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Input,
  FormControl,
  FormLabel,
  useToast,
  IconButton,
  Select,
  Badge,
  SimpleGrid,
  Icon,
  NumberInput,
  NumberInputField,
  Checkbox,
  CheckboxGroup,
  Stack,
  Spinner,
} from '@chakra-ui/react';
import { MdLocalOffer, MdDelete, MdAddCircle, MdEdit } from 'react-icons/md';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Card from 'components/card/Card';

export default function PromoManagement() {
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [editId, setEditId] = useState(null);

  // Form State
  const [formData, setFormData] = useState({
    code: '',
    discountType: 'percentage',
    discountValue: 0,
    maxDiscount: 0,
    minPurchase: 0,
    usageLimit: 100,
    expiryDate: '',
    applicableMonths: [], // [1, 3, 6, 12]
  });

  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const toast = useToast();
  const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/');
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchPromos = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${baseUrl}api/promo/list`, { headers });
      setPromos(res.data.data || []);
    } catch (err) {
      toast({ title: 'Error fetching promos', status: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPromos();
  }, []);

  const handleAddPromo = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    try {
      await axios.post(`${baseUrl}api/promo/add`, formData, { headers });
      toast({ title: 'Promo Code Added!', status: 'success' });
      setFormData({
        code: '',
        discountType: 'percentage',
        discountValue: 0,
        maxDiscount: 0,
        minPurchase: 0,
        usageLimit: 100,
        expiryDate: '',
        applicableMonths: [],
      });
      fetchPromos();
    } catch (err) {
      toast({ title: err.response?.data?.message || 'Error', status: 'error' });
    } finally {
      setBtnLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this promo code?')) {
      try {
        await axios.delete(`${baseUrl}api/promo/delete/${id}`, { headers });
        fetchPromos();
      } catch (err) {
        toast({ title: 'Delete failed', status: 'error' });
      }
    }
  };

  const handleUpdatePromo = async (e) => {
    e.preventDefault();
    setBtnLoading(true);

    try {
      await axios.patch(`${baseUrl}api/promo/update/${editId}`, formData, {
        headers,
      });

      toast({
        title: 'Promo updated successfully',
        status: 'success',
      });

      setEditId(null);

      setFormData({
        code: '',
        discountType: 'percentage',
        discountValue: 0,
        maxDiscount: 0,
        minPurchase: 0,
        usageLimit: 100,
        expiryDate: '',
        applicableMonths: [],
      });

      fetchPromos();
    } catch (err) {
      toast({
        title: err.response?.data?.message || 'Update failed',
        status: 'error',
      });
    } finally {
      setBtnLoading(false);
    }
  };
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SimpleGrid columns={{ base: 1, md: 3 }} gap="20px" mb="20px">
        {/* ADD PROMO FORM */}
        <Card p="20px" gridColumn={{ md: 'span 1' }}>
          <Text color={textColor} fontSize="xl" fontWeight="700" mb="20px">
            Create Promo Code
          </Text>
          <form onSubmit={editId ? handleUpdatePromo : handleAddPromo}>
            <Stack spacing={4}>
              <FormControl isRequired>
                <FormLabel fontSize="sm">Promo Code</FormLabel>
                <Input
                  placeholder="EX: NEET2024"
                  value={formData.code}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      code: e.target.value.toUpperCase(),
                    })
                  }
                />
              </FormControl>

              <Flex gap={3}>
                <FormControl isRequired>
                  <FormLabel fontSize="sm">Type</FormLabel>
                  <Select
                    value={formData.discountType}
                    onChange={(e) =>
                      setFormData({ ...formData, discountType: e.target.value })
                    }
                  >
                    <option value="percentage">Percentage (%)</option>
                    <option value="fixed">Fixed (₹)</option>
                  </Select>
                </FormControl>
                <FormControl isRequired>
                  <FormLabel fontSize="sm">Value</FormLabel>
                  <Input
                    type="number"
                    value={formData.discountValue}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        discountValue: e.target.value,
                      })
                    }
                  />
                </FormControl>
              </Flex>

              <Flex gap={3}>
                <FormControl>
                  <FormLabel fontSize="sm">Min Purchase</FormLabel>
                  <Input
                    type="number"
                    value={formData.minPurchase}
                    onChange={(e) =>
                      setFormData({ ...formData, minPurchase: e.target.value })
                    }
                  />
                </FormControl>
                <FormControl>
                  <FormLabel fontSize="sm">Max Discount</FormLabel>
                  <Input
                    type="number"
                    value={formData.maxDiscount}
                    onChange={(e) =>
                      setFormData({ ...formData, maxDiscount: e.target.value })
                    }
                  />
                </FormControl>
              </Flex>

              <FormControl isRequired>
                <FormLabel fontSize="sm">Expiry Date</FormLabel>
                <Input
                  type="date"
                  value={formData.expiryDate}
                  onChange={(e) =>
                    setFormData({ ...formData, expiryDate: e.target.value })
                  }
                />
              </FormControl>

              <FormControl>
                <FormLabel fontSize="sm">Applicable for (Months)</FormLabel>
                <CheckboxGroup
                  colorScheme="brand"
                  value={formData.applicableMonths}
                  onChange={(val) =>
                    setFormData({
                      ...formData,
                      applicableMonths: val.map(Number),
                    })
                  }
                >
                  <Stack direction="row" wrap="wrap" spacing={4}>
                    {[1, 3, 6, 12, 24].map((m) => (
                      <Checkbox key={m} value={m}>
                        {m}m
                      </Checkbox>
                    ))}
                  </Stack>
                </CheckboxGroup>
              </FormControl>

              <Button
                colorScheme={editId ? 'blue' : 'brand'}
                type="submit"
                isLoading={btnLoading}
                leftIcon={editId ? <MdLocalOffer /> : <MdAddCircle />}
              >
                {editId ? 'Update Promo Code' : 'Save Promo Code'}
              </Button>
            </Stack>
          </form>
        </Card>

        {/* PROMO LIST TABLE */}
        <Card p="20px" gridColumn={{ md: 'span 2' }} overflowX="auto">
          <Text color={textColor} fontSize="xl" fontWeight="700" mb="20px">
            Existing Promos
          </Text>
          {loading ? (
            <Spinner />
          ) : (
            <Table variant="simple" size="sm">
              <Thead bg={useColorModeValue('gray.50', 'navy.800')}>
                <Tr>
                  <Th>Code</Th>
                  <Th>Discount</Th>
                  <Th>Usage</Th>
                  <Th>Expiry</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {promos.map((p) => (
                  <Tr key={p._id}>
                    <Td fontWeight="bold">{p.code}</Td>
                    <Td>
                      {p.discountType === 'percentage'
                        ? `${p.discountValue}%`
                        : `₹${p.discountValue}`}
                      <Text fontSize="xs" color="gray.500">
                        Min: ₹{p.minPurchase}
                      </Text>
                    </Td>
                    <Td>
                      {p.usedCount || 0} / {p.usageLimit}
                    </Td>
                    <Td>
                      <Badge
                        colorScheme={
                          new Date(p.expiryDate) < new Date() ? 'red' : 'green'
                        }
                      >
                        {new Date(p.expiryDate).toLocaleDateString()}
                      </Badge>
                    </Td>
                    <Td>
                      <IconButton
                        icon={<MdEdit />}
                        colorScheme="blue"
                        size="sm"
                        mr={2}
                        onClick={() => {
                          setEditId(p._id);
                          setFormData({
                            code: p.code,
                            discountType: p.discountType,
                            discountValue: p.discountValue,
                            maxDiscount: p.maxDiscount,
                            minPurchase: p.minPurchase,
                            usageLimit: p.usageLimit,
                            expiryDate: p.expiryDate.split('T')[0],
                            applicableMonths: p.applicableMonths || [],
                          });
                        }}
                      />
                      <IconButton
                        icon={<MdDelete />}
                        colorScheme="red"
                        size="sm"
                        onClick={() => handleDelete(p._id)}
                      />
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </Card>
      </SimpleGrid>
    </Box>
  );
}
